// extracted by mini-css-extract-plugin
export default {"icon":"Instagram_icon__8r2TN","disabled":"Instagram_disabled__-y0XD"};